import * as React from 'react';
import { IBoxProps, Box } from '@lce/slice';

import { isExternal } from '../../lib/util';
import * as Styled from './BannerLink.style';

export interface IBannerLinkProps extends IBoxProps {
  href?: string;
  title?: string;
}

export const BannerLink: React.FC<IBannerLinkProps> = ({ title, href, children, ...props }) => {
  if (!href) {
    return <>{children}</>;
  }

  //the conditional check for deals.littlecaesars.com and test-deals.littlecaesars.com can go away once the microsite goes away
  let external = false;
  if (window.location.host !== "deals.littlecaesars.com" && window.location.host !== "test-deals.littlecaesars.com") {
    external = isExternal(href);
  }  

  if (external) {
    return <Styled.SuperLink href={href} title={title} {...props}>{children}</Styled.SuperLink>;
  }

  return <Box as="a" href={href} title={title} {...props}>{children}</Box>;
}
